import { Color } from "@mui/material";
import figma from "../figma.json";

/**
 * Variables used in design system
 * Reference: https://www.figma.com/file/eV4XPOxkDikhuFxiRYoMXK/REACT-Centric-Design-System?node-id=24%3A2
 *
 * Run "npm run figma" to update figma.json file with latest values
 * 
 * NOTE: manually add entries to interface as new variables are added to design system to support auto-completion
 */

export interface SkinVariables {
	CountIndicatorSelected: string;
	FocusPrimary: string;
	FocusSecondary: string;
	HighlightSelected: string;
	LinkDefault: string;
	LinkHover: string;
	NavListItemSelectedBG: string;
	PrimaryDefault: string;
	PrimaryDisabledBG: string;
	PrimaryHoverPressedBG: string;
	PrimaryPressedBorder: string;
	SelectedTabText: string;
	SiteHeaderBG: string;
	SiteHeaderText: string;
}

/**
 * Extract Color object from figma file for given base color
 */
function getColorMap(color: string): Partial<Color> {
	const colors = figma[color];
	const result = {};

	for (const key in colors) {
		const n = key.split("-")[0];
		result[n === "1000" ? "A100" : n] = colors[key];
	}

	return result;
}

export const grey = getColorMap("Grey");
export const black = getColorMap("Black");
export const blue = getColorMap("Blue");
export const charcoal = getColorMap("Charcoal");
export const cyan = getColorMap("Cyan");
export const green = getColorMap("Green");
export const magenta = getColorMap("Magenta");
export const mutedPurple = getColorMap("MutedPurple");
export const orange = getColorMap("Orange");
export const purple = getColorMap("Purple");
export const red = getColorMap("Red");
export const white = getColorMap("White");
export const yellow = getColorMap("Yellow");

export const boxShadows = {
	activeButton: "rgba(0,0,0,0.3) 0px 1px 3px 0px inset",
	card: "0 2px 4px rgba(0, 0, 0, 0.2)",
	dialog: "0 3px 6px 0 rgba(0,0,0,.15)",
	iconButton: "0 2px 4px rgba(0, 0, 0, 0.1)",
	popper: "0 1px 3px 0 rgba(0,0,0,.15)",
};

/**
 * Return object containing variables for given skin 
 */
export function getSkinVariables(skinName: string): SkinVariables {
	return figma[skinName];
}

